{
  "title": "Chia sẻ vị trí giúp bạn đẩy nhanh quy trình check-in",
  "body": "Rất tiếc, chúng tôi không thể hoàn tất check-in của bạn nếu không có quyền truy cập vị trí. Vui lòng cấp quyền truy cập vị trí để tiếp tục. Chúng tôi chỉ sử dụng vị trí của bạn cho mục đích check-in tại kho hàng và không lưu trữ hoặc chia sẻ thông tin vị trí của bạn với bên thứ ba.",
  "shareLocation": "Chia sẻ vị trí của tôi"
}
